import { useEffect, useRef } from 'react'

// 'Full months' searches every day of the selected months, so Days to monitor is not used: the field is disabled and
// holds 1 (the column is NOT NULL and the backend requires the field). Leaving the option restores the user's value.
export const FULL_MONTHS_DAYS_MONITORIZED = 1

export default function useFullMonthsDaysMonitorized(isFullMonths, value, onChange) {
    const previousValue = useRef(null)

    useEffect(() => {
        if (isFullMonths) {
            previousValue.current = value
            onChange(FULL_MONTHS_DAYS_MONITORIZED)
        } else if (previousValue.current !== null) {
            onChange(previousValue.current)
            previousValue.current = null
        }
        // only on option change: value is read at that moment, onChange is stable
        // eslint-disable-next-line
    }, [isFullMonths])
}
